import React from 'react';
import { RecoilRoot } from 'recoil';
import MainRoutes from './MainRoutes';
import { Provider } from 'react-redux';
import store from './store';
import { ThemeProvider } from '@shopuptech/expo-shopup-ui';
import { theme } from './config';

const Main = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme} choosenLang="en">
        <RecoilRoot>
          <MainRoutes />
        </RecoilRoot>
      </ThemeProvider>
    </Provider>
  );
};

export default Main;
